import { Drawer, H1, P, Small } from '@ahmdigital/ui';
import { LEAD_SOURCE_TYPES } from '@ahmdigital/constants';
import { tagmanager as TagManager } from '@ahmdigital/analytics';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { DRAWER_IDS } from '../../../ahm-constants/ui';
import { LEAD_MESSAGES, LEAD_TYPES } from '../../../models/lead-capture/constants';
import { productPageFailedMessage, productPageSuccessMessage } from '../constants';
import DrawerActions from '../../../actions/drawer';
import LeadCaptureForm from '../../lead-capture-form';
import RequestACallActions from '../../../actions/request-a-call';
import selectCurrentDrawer from '../../../selectors/select-current-drawer';
import styles from './styles.module.sass';

const RequestACallDrawer = () => {
  const closeDrawerDelay = 2000;
  const requestACall = useSelector((state: any) => state.requestACall);
  const drawer = useSelector(selectCurrentDrawer);
  const dispatch = useDispatch();
  const captureRequestACall = useCallback(() => {
    RequestACallActions.drawerCapture()(dispatch);
  }, [dispatch]);
  const closeGetACallBackDrawer = useCallback(() => {
    DrawerActions.closeDrawer()(dispatch);
    RequestACallActions.drawerDismiss()(dispatch);
  }, [dispatch]);

  const { failed, recordId, submitted } = requestACall;
  const { message, requiredFieldsMessage, submitButtonText, title } = LEAD_MESSAGES.REQUEST_A_CALL;

  const [loading, setLoading] = useState(false);

  const isOpen = drawer === DRAWER_IDS.GET_A_CALL_BACK;

  // @ts-expect-error - Automatic, Please fix when editing this file
  const onRequestACallSubmit = (values) => {
    setLoading(true);
    TagManager.submit('request_a_callback', {
      // eslint-disable-next-line camelcase
      is_member: values.isMember ? 'yes' : 'no',
    });
    captureRequestACall();
  };

  useEffect(() => {
    if (submitted && recordId) {
      setLoading(false);
      setTimeout(closeGetACallBackDrawer, closeDrawerDelay);
    }
    if (failed) setLoading(false);
  }, [closeGetACallBackDrawer, failed, recordId, submitted]);

  const requestACallFormContainer = (
    <>
      {failed && productPageFailedMessage}
      <H1 looksLike="h4" variant={styles.text}>
        {title}
      </H1>
      <P variant={styles.text}>{message}</P>
      <Small variant={['small14', styles.text, styles.small]}>{requiredFieldsMessage}</Small>
      <LeadCaptureForm
        leadType={LEAD_TYPES.REQUEST_A_CALL}
        onSubmit={onRequestACallSubmit}
        sourceType={LEAD_SOURCE_TYPES.REQUEST_A_CALL}
        submitButtonText={submitButtonText}
        isLoading={loading}
      />
    </>
  );

  return (
    <Drawer title="" isOpen={isOpen} toggleMenu={closeGetACallBackDrawer}>
      {submitted && recordId ? productPageSuccessMessage : requestACallFormContainer}
    </Drawer>
  );
};

export default RequestACallDrawer;
